require("!!/var/www/melochenator_prod/frontend/node_modules/script-loader/addScript.js")(require("!!/var/www/melochenator_prod/frontend/node_modules/raw-loader/index.js!/var/www/melochenator_prod/frontend/node_modules/source-map-loader/index.js!/var/www/melochenator_prod/frontend/src/assets/js/pace/pace.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/pace/pace.min.js
// module id = 910
// module chunks = 12